import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { PiInfo, PiPlus, PiTrash } from "react-icons/pi";
import { useNavigate, useParams } from "react-router-dom";
import { Inputs, NavAndTabs } from "../../../components";
import { useDispatch, useSelector } from "react-redux";
import { actionPatient } from "../../../redux/actions";

const HealthInformation = ({ loginData }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { subId } = useParams();
  const [activeTab, setActiveTab] = useState(subId || "health-tracking");
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  useEffect(() => {
    setActiveTab(subId || "health-tracking");
  }, [subId]);
  const onTabChange = (tabId) => {
    setActiveTab(tabId);
    navigate(`/patient/my-profile/health-information/${tabId}`);
  };
  const labelMappings = {
    0: { label1: t("patient_Details.right_eye"), label2: t("patient_Details.right_eye") },
    1: { label1: t("patient_Details.moderate_consumption") },
    2: { label1: t("patient_Details.smoking_status") },
    3: { label1: t("patient_Details.fasting_glucose") },
    4: {
      label1:
        t("patient_Details.hba1c"),
    },
    5: { label1: t("patient_Details.fasting_glucose") },
    6: { label1: t("patient_Details.pap_smear_result") },
    7: { label1: t("patient_Details.blood_pressure") },
  };

  useEffect(() => {
    let pageNo = getPageNoFromTab(activeTab);
    dispatch(actionPatient.getQuestion(pageNo, loginData?.languageAbb));
    dispatch(actionPatient.getAnswers(loginData?.userGuid, pageNo));
  }, [dispatch, loginData?.languageAbb, loginData?.userGuid, activeTab]);

  const getPageNoFromTab = (tabId) => {
    switch (tabId) {
      case "health-tracking":
        return 1;
      case "hearing-and-seeing":
        return 2;
      case "digestion-and-nutrition":
        return 3;
      case "chronic-diseases-and-conditions":
        return 4;
      case "recent-medical-history":
        return 5;
      case "medication-intake":
        return 6;
      default:
        return 1;
    }
  };

  const questionData = useSelector(
    (state) => state.patient.getQuestionData?.data?.result || []
  );
  const answersData = useSelector(
    (state) => state.patient.getAnswersData?.data?.result || []
  );

  const tabs = [
    {
      id: "health-tracking",
      label: (
        <>
          1.{" "}
          <span className="nav-link-span">
            {t("patient_Details.health_information.health_tracking")}
          </span>
        </>
      ),
      content: (
        <>
          {questionData.map((que, index) => (
            <div key={index} className="health-info-que-ans-tab-blk">
              <p className="exado-title-seven health-info-que">
                {que.question}
              </p>
              {que.questionType === 2 && (
                <div className="health-info-que-input-blk">
                  <Inputs.FormInputs
                    label={
                      errors.firstName ? (
                        <span className="error-message">
                          {" "}
                          {errors.firstName}
                        </span>
                      ) : (
                        t("right_eye")
                      )
                    }
                    placeholder="Enter number"
                    name="firstName"
                    // value={credentials1.firstName}
                    // onChange={handleChange}
                    grpClassname={`form-group ${errors.firstName ? "form-group-error" : ""
                      }`}
                  // disabled={!isEditVisible}
                  />
                  <Inputs.FormInputs
                    label={
                      errors.firstName ? (
                        <span className="error-message">
                          {" "}
                          {errors.firstName}
                        </span>
                      ) : (
                        t("left_eye")
                      )
                    }
                    placeholder="Enter number"
                    name="firstName"
                    // value={credentials1.firstName}
                    // onChange={handleChange}
                    grpClassname={`form-group ${errors.firstName ? "form-group-error" : ""
                      }`}
                  // disabled={!isEditVisible}
                  />
                </div>
              )}
              <div className="hiqatb-add-new">
                <span
                  className="custom-cursor-pointer exado_body_text"
                // onClick={handleAddDocument}
                >
                  {t("doctor.diagnostic_report.add_new")}
                  <PiPlus className="adn-icn exado_body_text" />
                </span>
              </div>
              <p className="exado_body_text past-entries">{t("past_entries")}</p>
              {answersData.map((ans, ansIndex) =>
                ans.questionGuid === que.questionGuid ? (
                  <div key={ansIndex} className="past-entries-data">
                    <div className="past-entries-datalist">
                      <div>{ans.createdDate}</div>
                      <div>
                        {labelMappings[index]?.label1 || ""}: {ans.answer1}
                        {labelMappings[index]?.label2 && (
                          <>
                            {" "}
                            {labelMappings[index].label2}: {ans.answer2}
                          </>
                        )}
                      </div>
                    </div>
                    <PiTrash />
                  </div>
                ) : null
              )}
            </div>
          ))}
          <pre>{JSON.stringify(questionData, null, 2)}</pre>
          <pre>{JSON.stringify(answersData, null, 2)}</pre>
        </>
      ),
      disabled: false,
    },
    {
      id: "hearing-and-seeing",
      label: (
        <>
          2.{" "}
          <span className="nav-link-span">
            {t("patient_Details.health_information.hearing_and_seeing")}
          </span>
        </>
      ),
      content: (
        <>
          Hearing And Seeing
          <pre>{JSON.stringify(questionData, null, 2)}</pre>
          <pre>{JSON.stringify(answersData, null, 2)}</pre>
        </>
      ),
      disabled: false,
    },
    {
      id: "digestion-and-nutrition",
      label: (
        <>
          3.{" "}
          <span className="nav-link-span">
            {t("patient_Details.health_information.digestion_and_nutrition")}
          </span>
        </>
      ),
      content: (
        <>
          digestion-and-nutrition
          <pre>{JSON.stringify(questionData, null, 2)}</pre>
          <pre>{JSON.stringify(answersData, null, 2)}</pre>
        </>
      ),
      disabled: false,
    },
    {
      id: "chronic-diseases-and-conditions",
      label: (
        <>
          4.{" "}
          <span className="nav-link-span">
            {t("patient_Details.health_information.chronic_diseases")}
          </span>
        </>
      ),
      content: <></>,
      disabled: false,
    },
    {
      id: "recent-medical-history",
      label: (
        <>
          5.{" "}
          <span className="nav-link-span">
            {t("patient_Details.health_information.recent_medical_history")}
          </span>
        </>
      ),
      content: <></>,
      disabled: false,
    },
    {
      id: "medication-intake",
      label: (
        <>
          6.{" "}
          <span className="nav-link-span">
            {t("patient_Details.health_information.medication_intake")}
          </span>
        </>
      ),
      content: <></>,
      disabled: false,
    },
  ];

  return (
    <Container fluid className="exado-container1">
      <Row className="exado-row1">
        <Col>
          <p className="exado-title-six d-flex align-items-center">
            <div>
              <PiInfo className="ai-piInfo" />
            </div>
            <div>{t("patient_Details.health_information.information")}</div>
          </p>
        </Col>
      </Row>
      <Row className="exado-row1">
        <Col>
          <NavAndTabs.NavAndTabs
            tabs={tabs}
            activeTab={activeTab}
            onTabChange={onTabChange}
            tabClassName="nav-and-tab1"
            contentClassname="nav-and-tab-content1"
          />
        </Col>
      </Row>
    </Container>
  );
};

export default HealthInformation;
